var render, staticRenderFns
import script from "./VToast.vue?vue&type=script&lang=js&"
export * from "./VToast.vue?vue&type=script&lang=js&"
import style0 from "./VToast.vue?vue&type=style&index=0&id=240c598a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c598a",
  null
  
)

export default component.exports